import Model, { attr } from '@ember-data/model';

export default class JournalContactModel extends Model {
  @attr('string') declare journalId: string;
  @attr('string') declare contactId: string;
  @attr('date-only') declare addedDate: Date;
  @attr('string') askAmount?: number;
  @attr('string') notes?: string;
  @attr('boolean') declare finished: boolean;
  @attr() declare segments: string[];

  get sortedSegments() {
    return this.segments.sort();
  }
}
